import React from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { useRemainingWidth } from '../width-context';
import { CommentStart, CommentEnd } from '../comments';
import { ColumnItem } from '../column-item';
import { useConfig } from '../config-context';
export function Divider(props) {
    const { borderColor = '#000000', borderWidth = '4px', cssClass, padding = '10px 25px', paddingBottom, paddingLeft, paddingRight, paddingTop, width = '100%', } = props;
    const { width: remainingWidth } = useRemainingWidth({
        width,
        padding,
        paddingLeft,
        paddingRight,
    });
    const { renderComments } = useConfig();
    return (React.createElement(ColumnItem, { align: "center", padding: padding, cssClass: cssClass, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, paddingTop: paddingTop },
        React.createElement("p", { style: {
                borderTop: `solid ${borderWidth} ${borderColor}`,
                fontSize: '1px',
                margin: '0px auto',
                width,
            } }),
        renderComments && (React.createElement(React.Fragment, null,
            React.createElement(CommentStart, null),
            React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", style: {
                    borderTop: `solid ${borderWidth} ${borderColor}`,
                    fontSize: '1px',
                    margin: '0px auto',
                    width: `${remainingWidth}px`,
                }, role: "presentation", width: `${remainingWidth}px` },
                React.createElement("tr", null,
                    React.createElement(SecureHtml, { containerProps: { style: { height: '0', lineHeight: '0' } }, html: '&nbsp;', as: "td", skipCleaning: true }))),
            React.createElement(CommentEnd, null)))));
}
//# sourceMappingURL=divider.js.map